// frontend/klaes-app/src/components/FilmFavs/components/DeleteConfirmModal.jsx
import { FiTrash2, FiX } from 'react-icons/fi';
import { styles } from '../styles';

export const DeleteConfirmModal = ({ entryName, onConfirm, onClose }) => {
  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>Eintrag löschen</h3>
        <p style={{ marginBottom: '1rem' }}>
          <strong>"{entryName}"</strong> wirklich löschen?
          <br />
          Diese Aktion kann nicht rückgängig gemacht werden.
        </p>
        <div className={styles.modalButtons}>
          <button onClick={onConfirm} className={styles.modalDeleteConfirmBtn}>
            <FiTrash2 /> Ja, löschen
          </button>
          <button onClick={onClose} className={styles.modalDeleteCancelBtn}>
            <FiX /> Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
};